import { StatutAvisEnum } from 'src/app/models/enums/statut-avis.enum';
import { FormsEnum } from '../../../../models/enums/forms.enum';
import { Avis } from '../../../../models/avis';

export class AvisItem {

    public numero: String;
    public avisId: number;
    public statut: StatutAvisEnum;
    public typeAvis: String;
    public datedecreation: Date;
    public datedemodification: Date;
    public typedemarche: String;
    public referencedelaconsultation: String;
    public formulairecode: string;
    public norme: string;
    public raisonSociale: string;
    public service: string;
    public urlBoamp: string;
    public liables: FormsEnum[];
    public reliables: Avis[];
    public isLie: boolean;
    public diffuseurs: number[];
    public supportdediffusion: string[];
    public formulairevalues: any;
    public intituledeformulaire: string;
    public datedepublication: Date;
    public datedenvoi: Date;
    public motif: string;
    public eformIdParentNotice: string;
    public hasAvisLies: boolean;

    constructor() {}
}
